import { render } from "./CallbackTable.vue?vue&type=template&id=184ab52e&scoped=true"
import script from "./CallbackTable.vue?vue&type=script&lang=js"
export * from "./CallbackTable.vue?vue&type=script&lang=js"

import "./CallbackTable.vue?vue&type=style&index=0&id=184ab52e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184ab52e"]])

export default __exports__